import { BusRoute, BusRouteDataMap } from './route-types';

// tianjin
export const busRoutes = [
  {
    route: 'Bus 8',
    id: '8',
  },
  {
    route: 'Bus 11',
    id: '11',
  },
  // {
  //   route: 'Bus 118',
  //   id: '118',
  // },
  // {
  //   route: 'Bus 888',
  //   id: '888',
  // },
];

// refactor to combine stop data and route data so we don't have to maintain two lists for stop info
const routeA: BusRoute = {
  routeName: 'Bus 8',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'A1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'A2',
          index: 5,
        },
        {
          stopSequence: '3',
          stopCode: 'A3',
          index: 37,
        },
        {
          stopSequence: '4',
          stopCode: 'A4',
          index: 46,
        },
        {
          stopSequence: '5',
          stopCode: 'A5',
          index: 60,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'A6',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'A7',
          index: 9,
        },
        {
          stopSequence: '3',
          stopCode: 'A8',
          index: 18,
        },
        {
          stopSequence: '4',
          stopCode: 'A9',
          index: 46,
        },
        {
          stopSequence: '5',
          stopCode: 'A10',
          index: 53,
        },
      ],
    },
  ],
  // color: '#038803',
  // colorAlt: '#086608',
  // colorAlt2: '#064A06',
  busCode: 'A',
  busCount: 1,
  busId: 8,
  busIdStr: '8',
  busArr: ['AV01'],
  timeStop: 5,
  timeslotPeriodMinutes: 2,
  isFixed: true,
};

const routeB: BusRoute = {
  routeName: 'Bus 11',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'B1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'B2',
          index: 10,
        },
        {
          stopSequence: '3',
          stopCode: 'B3',
          index: 37,
        },
        {
          stopSequence: '4',
          stopCode: 'B4',
          index: 77,
        },
        {
          stopSequence: '5',
          stopCode: 'B5',
          index: 118,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'B6',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'B7',
          index: 29,
        },
        {
          stopSequence: '3',
          stopCode: 'B8',
          index: 55,
        },
        {
          stopSequence: '4',
          stopCode: 'B9',
          index: 80,
        },
        {
          stopSequence: '5',
          stopCode: 'B10',
          index: 90,
        },
      ],
    },
  ],
  // color: '#f03030',
  // colorAlt: '#991010',
  // colorAlt2: '#600808',
  busCode: 'B',
  busCount: 1,
  busId: 11,
  busIdStr: '11',
  busArr: ['AV02'],
  timeStop: 5,
  timeslotPeriodMinutes: 60,
  isFixed: true,
};

const routeC: BusRoute = {
  routeName: 'Bus 118',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'B6',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'B7',
          index: 1,
        },
        {
          stopSequence: '3',
          stopCode: 'B8',
          index: 2,
        },
        {
          stopSequence: '4',
          stopCode: 'B9',
          index: 3,
        },
        {
          stopSequence: '5',
          stopCode: 'A1',
          index: 0,
        },
        {
          stopSequence: '6',
          stopCode: 'A2',
          index: 1,
        },
        {
          stopSequence: '7',
          stopCode: 'A3',
          index: 2,
        },
        {
          stopSequence: '8',
          stopCode: 'A4',
          index: 3,
        },
        {
          stopSequence: '9',
          stopCode: 'A5',
          index: 4,
        },
      ],
    },
    {
      direction: 2,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'A6',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'A7',
          index: 1,
        },
        {
          stopSequence: '3',
          stopCode: 'A8',
          index: 2,
        },
        {
          stopSequence: '4',
          stopCode: 'A10',
          index: 4,
        },
        {
          stopSequence: '5',
          stopCode: 'B1',
          index: 0,
        },
        {
          stopSequence: '6',
          stopCode: 'B2',
          index: 1,
        },
        {
          stopSequence: '7',
          stopCode: 'B3',
          index: 2,
        },
        {
          stopSequence: '8',
          stopCode: 'B4',
          index: 3,
        },
        {
          stopSequence: '9',
          stopCode: 'B5',
          index: 4,
        },
      ],
    },
  ],
  // color: '#f03030',
  // colorAlt: '#991010',
  // colorAlt2: '#600808',
  busCode: 'C',
  busCount: 1,
  busId: 118,
  busIdStr: '118',
  busArr: ['AV03'],
  timeStop: 5,
  timeslotPeriodMinutes: 60,
  isFixed: true,
};

const routeD: BusRoute = {
  routeName: 'Bus 888',
  stops: [
    {
      direction: 1,
      stop: [
        {
          stopSequence: '1',
          stopCode: 'A1',
          index: 0,
        },
        {
          stopSequence: '2',
          stopCode: 'A2',
          index: 4,
        },
        {
          stopSequence: '3',
          stopCode: 'A3',
          index: 35,
        },
        {
          stopSequence: '4',
          stopCode: 'A4',
          index: 44,
        },
        {
          stopSequence: '5',
          stopCode: 'A5',
          index: 56,
        },
        {
          stopSequence: '6',
          stopCode: 'A6',
          index: 63,
        },
        {
          stopSequence: '7',
          stopCode: 'A7',
          index: 71,
        },
        {
          stopSequence: '8',
          stopCode: 'A8',
          index: 78,
        },
        {
          stopSequence: '9',
          stopCode: 'A9',
          index: 105,
        },
        {
          stopSequence: '10',
          stopCode: 'A10',
          index: 110,
        },
        {
          stopSequence: '11',
          stopCode: 'B2',
          index: 115,
        },
        {
          stopSequence: '12',
          stopCode: 'B3',
          index: 141,
        },
        {
          stopSequence: '13',
          stopCode: 'B4',
          index: 180,
        },
        {
          stopSequence: '14',
          stopCode: 'B5',
          index: 221,
        },
        {
          stopSequence: '15',
          stopCode: 'B6',
          index: 250,
        },
        {
          stopSequence: '16',
          stopCode: 'B7',
          index: 281,
        },
        {
          stopSequence: '17',
          stopCode: 'B8',
          index: 306,
        },
        {
          stopSequence: '18',
          stopCode: 'B9',
          index: 331,
        },
        {
          stopSequence: '19',
          stopCode: 'A1',
          index: 24,
        },
        {
          stopSequence: '20',
          stopCode: 'A2',
          index: 30,
        },
      ],
    },
  ],
  // color: '#f03030',
  // colorAlt: '#991010',
  // colorAlt2: '#600808',
  busCode: 'D',
  busCount: 2,
  busId: 888,
  busIdStr: '888',
  busArr: ['AV04', 'AV05'],
  timeStop: 5,
  timeslotPeriodMinutes: 60,
  isFixed: true,
};

export const routeData: BusRouteDataMap = {
  '8': routeA,
  '11': routeB,
  // '118': routeC,
  // '888': routeD,
};

export const stopNames = {
  A1: 'Zhong Sheng Avenue A',
  A2: 'Hilton Hotels A',
  A3: 'Jinxiang Wildlife Park A',
  A4: 'Fantawild Adventure A',
  A5: 'Boonie Bears Hotel A',
  A6: 'Boonie Bears Hotel B',
  A7: 'Fantawild Adventure B',
  A8: 'Jinxiang Wildlife Park B',
  A9: 'Hilton Hotels B',
  A10: 'Zhong Sheng Avenue B',
  B1: 'Hilton Hotels B',
  B2: 'Ecological Valley Greenway Park B',
  B3: 'Binlv Industrial Park B',
  B4: 'Aegean Sea Shopping Park B',
  B5: 'Ecological Valley Greenway Park B',
  B6: 'National Maritime Museum A',
  B7: 'Aegean Sea Shopping Park A',
  B8: 'Binlv Industrial Park A',
  B9: 'Ecological Valley Greenway Park A',
  B10: 'Hilton Hotels A',
};
